import { useQuery } from "react-query";
import { getKeyTypes } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useGetKeyType = () => {
  const { data, isLoading, refetch } = useQuery("GetKeyTypes", getKeyTypes, {
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, refetch };
};
